export type TaskTrackerPermissionKey =
  | 'tasks:edit'
  | 'tasks:delete'
  | 'columns:manage'
  | 'board:settings'
  | 'automations:manage'
  | 'summaries:manage'

export const TASK_TRACKER_TASKS_EDIT_DISABLED_TOOLTIP =
  'У вашей роли нет права «Редактирование задач»'

export const TASK_TRACKER_TASKS_DELETE_DISABLED_TOOLTIP =
  'У вашей роли нет права «Удаление задач»'

export const TASK_TRACKER_BOARD_SETTINGS_DISABLED_TOOLTIP =
  'У вашей роли нет права «Настройки доски»'

export const TASK_TRACKER_COLUMNS_MANAGE_DISABLED_TOOLTIP =
  'У вашей роли нет права «Управление колонками»'

export const TASK_TRACKER_AUTOMATIONS_MANAGE_DISABLED_TOOLTIP =
  'У вашей роли нет права «Автоматизации»'

export const TASK_TRACKER_SUMMARIES_MANAGE_DISABLED_TOOLTIP =
  'У вашей роли нет права «Добавлять сводку»'

export const TASK_TRACKER_BOARD_STICKER_REQUIRED_HIDE_TOOLTIP =
  'Обязательный на этой доске стикер нельзя скрыть'

export const TASK_TRACKER_CURRENT_USER_NO_BOARD_ACCESS_TOOLTIP =
  'У вас нет доступа к этой доске'

export const TASK_TRACKER_NOT_IN_PROJECT_MESSAGE =
  'Вы не добавлены в этот проект'

export const TASK_TRACKER_NOT_IN_BOARD_MESSAGE =
  'Вы не добавлены в эту доску'

export const TASK_TRACKER_PROJECT_SETTINGS_DISABLED_TOOLTIP =
  'Настройки проекта доступны только администратору проекта'

export const hasTaskTrackerPermission = (
  permissions: string[] | null | undefined,
  permission: TaskTrackerPermissionKey,
) => Boolean(permissions?.includes(permission))

export const TASK_TRACKER_PERMISSION_OPTIONS: {
  value: TaskTrackerPermissionKey
  label: string
}[] = [
  { value: 'tasks:edit', label: 'Редактирование задач' },
  { value: 'tasks:delete', label: 'Удаление задач' },
  { value: 'columns:manage', label: 'Управление колонками' },
  { value: 'board:settings', label: 'Настройки доски' },
  { value: 'automations:manage', label: 'Автоматизации' },
  { value: 'summaries:manage', label: 'Добавлять сводку' },
]
